import { Icon, useTheme } from "react-native-paper";

export function NewItemIndicator() {
  const { colors } = useTheme();
  return <Icon source="circle-medium" size={16} color={colors.error} />;
}
